import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PropertyInfoCard from './PropertyDetailsComponents/PropertyInfoCard';
import Notes from './PropertyDetailsComponents/Notes';
import ApartmentSetup from './PropertyDetailsComponents/ApartmentSetup';
import LinenDepositSection from './PropertyDetailsComponents/LinenDepositSection';
import BookingsList from './PropertyDetailsComponents/BookingsList';
import PropertyTasks from './PropertyDetailsComponents/PropertyTasks';
import axios from 'axios';
import './propertyDetails.css';
import '../../SharedView/detailCards.css';
import { colorOf } from '../../../constants/areas';

function PropertyDetails() {
  const { propertyId } = useParams();
  const [property, setProperty] = useState(null);
  const [setupPhotos, setSetupPhotos] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const response = await axios.get(`/api/properties/${propertyId}`);
        setProperty(response.data);
      } catch (error) {
        console.error('Error fetching property:', error);
      }
    };

    fetchProperty();
  }, [propertyId]);

  useEffect(() => {
    const fetchSetupPhotos = async () => {
      try {
        const response = await axios.get(`/api/properties/${propertyId}/setup-photos`);
        setSetupPhotos(response.data);
      } catch (error) {
        console.error('Error fetching setup photos:', error);
      }
    };

    fetchSetupPhotos();
  }, [propertyId]);

  const updateNotes = (newNotes) => {
    setProperty((prevProperty) => ({
      ...prevProperty,
      permanent_notes: newNotes.permanent_notes,
      dissapearing_note: newNotes.dissapearing_note,
      warehouse_note: newNotes.warehouse_note,
      scheduling_note: newNotes.scheduling_note,
    }));
  };

  if (!property) {
    return (
      <div className="app-loading">
        <div className="app-spinner" />
        <div className="app-spinner-text">Loading Property Details...</div>
      </div>
    );
  }

  const bedroomDisplay = property.bedrooms === 0 ? 'S' : property.bedrooms;
  const propertyDisplay = `${property.client_display_name} - ${property.address_line_1} - Unit ${property.unit_number} (${bedroomDisplay} - ${property.bathrooms})`;

  const areaColor = colorOf(property.area);

  return (
    <div className="property-details-wrapper">
      {/* UNIT FIRST (brand rule): the thing everyone recognises leads, the
          internal id follows as a small reference chip. */}
      <div className="header">
        <div className="header-title">
          <h1 className="pd-title" style={{ color: areaColor }}>{propertyDisplay}</h1>
          <div className="pd-subline">
            <span className="pd-idChip">#{propertyId.toString().padStart(5, '0')}</span>
            {property.area && <span className="pd-areaChip" style={{ borderColor: areaColor, color: areaColor }}>{property.area}</span>}
          </div>
        </div>
        <button className="edit-button" onClick={() => navigate(`/properties/edit/${propertyId}`)}>
          Edit Property
        </button>
      </div>

      <div className="property-details-container dp-stack">
        {/* One dense card instead of four half-empty ones; the deposit ledger
            moved to the END of the stack (owner, 2026-09-02). */}
        <PropertyInfoCard property={property} />
        <PropertyTasks
          propertyId={propertyId}
          clientId={property?.client_id ?? property?.clientId ?? property?.clientID}
        />
        <ApartmentSetup setupPhotos={setupPhotos} propertyId={propertyId} />
        <LinenDepositSection propertyId={propertyId} isLinenHire={!!property.is_linen_hire} />
        <Notes property={property} propertyId={propertyId} updateNotes={updateNotes} />
        {/* BOOKINGS CLOSE THE PAGE (owner, 2026-09-07: "put back bookings at
            the bottom of property details, that's where it makes most sense
            and the easiest to find"). It is the longest, paged section, so
            everything about the unit itself reads first and the list runs
            off the end of the page instead of splitting it. */}
        <BookingsList propertyId={propertyId} />
      </div>
    </div>
  );
}

export default PropertyDetails;
